import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Card } from '../ui/Card';
export function Login() {
  const {
    login
  } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 800));
    login(email, password);
    setIsLoading(false);
  };
  return <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center px-4 transition-colors duration-200" data-id="element-263">
      <div className="w-full max-w-md" data-id="element-264">
        {/* Logo and Title */}
        <div className="text-center mb-8" data-id="element-265">
          <img src="https://cdn.magicpatterns.com/uploads/oMeYEvt4FAi4MGm33UZ8bU/MCPGuard-logo.png" alt="MCPGuard" className="h-64 mx-auto mb-6" data-id="element-266" />
          <p className="text-sm text-slate-500 dark:text-slate-400" data-id="element-267">
            Sign in to your account
          </p>
        </div>

        {/* Login Card */}
        <Card className="shadow-lg" data-id="element-268">
          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-269">
            <Input label="Email" type="email" placeholder="admin@example.com" value={email} onChange={e => setEmail(e.target.value)} required autoComplete="email" autoFocus data-id="element-270" />

            <Input label="Password" type="password" placeholder="Enter your password" value={password} onChange={e => setPassword(e.target.value)} required revealable autoComplete="current-password" data-id="element-271" />

            <Button type="submit" variant="primary" className="w-full mt-6" loading={isLoading} disabled={!email || !password} data-id="element-272">
              Sign In
            </Button>
          </form>

          <div className="mt-6 pt-6 border-t border-slate-100 dark:border-slate-800" data-id="element-273">
            <p className="text-xs text-center text-slate-500 dark:text-slate-400" data-id="element-274">
              Enterprise security platform for MCP server management
            </p>
          </div>
        </Card>
      </div>
    </div>;
}